import {useLocation, Navigate} from 'react-router-dom'
import {VerifyEmailInfo, useAuthStore} from '@/features/auth'
import {AppHeader} from '@/widgets/app-header'
import {cn} from '@/shared/lib'

const cardClassName = cn(
  'rounded-[20px] border border-primary/15 bg-card/80 p-6 sm:p-8',
  'backdrop-blur-[20px] transition-all duration-300',
  'shadow-(--shadow-card)',
)

export function VerifyEmailPage() {
  const location = useLocation()
  const isAuthenticated = useAuthStore(s => s.isAuthenticated)
  const email = (location.state as {email?: string} | null)?.email

  if (isAuthenticated) return <Navigate to="/" replace />
  if (!email) return <Navigate to="/register" replace />

  return (
    <div className="relative flex min-h-screen flex-col overflow-hidden">
      <AppHeader />
      <div className="relative flex flex-1 items-center justify-center px-4 py-8 sm:px-8 sm:py-0">
        <div className="w-full max-w-[460px] animate-in fade-in slide-in-from-bottom-3 duration-500">
          <div className={cardClassName}>
            <h1 className="mb-6 text-xl font-semibold text-center">Подтвердите почту</h1>
            <VerifyEmailInfo email={email} />
          </div>
        </div>
      </div>
    </div>
  )
}
